import { apiUrl, httpClient } from "@/utilities";
import {
  DataProvider,
  GetListParams,
  GetListResult,
  RaRecord,
} from "react-admin";

const gameoo_resource = "games";

const gameProvider: Partial<DataProvider> = {
  getList: async <RecordType extends RaRecord>(
    resource: string,
    params?: GetListParams
  ): Promise<GetListResult<RecordType>> => {
    if (resource !== gameoo_resource) return Promise.reject();
    const { page = 1, perPage = 10 } = params?.pagination ?? {};
    const { field = "", order = "" } = params?.sort ?? {};

    const query = params
      ? {
          filter: JSON.stringify(params.filter),
          range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
          sort: JSON.stringify([field, order]),
        }
      : "";

    const url = `${apiUrl}/${resource}?${new URLSearchParams(query)}`;
    const response = await httpClient(url);

    // Ensure response has `json` and headers
    if (!response.json || !Array.isArray(response.json.data)) {
      throw new Error(
        "Invalid API response: Expected { data: [...], total: number }"
      );
    }

    return {
      data: response.json.data,
      total: response.json.total ?? response.json.data.length,
    };
  },

  getMany: async (resource, params) => {
    if (resource !== gameoo_resource) return Promise.reject();
    const queryParams = new URLSearchParams({ ids: params.ids.join(",") });
    const url = `${apiUrl}/${resource}/many?${queryParams.toString()}`;
    const { json } = await httpClient(url);
    return { data: json };
  },
};

export default gameProvider;
